import React, { useState } from 'react';
import { GAN_WX, ZHI_WX } from './tables.js';

const WX_COLOR = { 木: '#2e7d32', 火: '#c62828', 土: '#9c6b3f', 金: '#607d8b', 水: '#1565c0' };
const REL_COLOR = { 生: '#2e7d32', 受生: '#1565c0', 克: '#c62828', 受克: '#e65100', 比: '#6a1b9a' };
const ROLE = { 年柱: '祖上·早年', 月柱: '父母·青年', 日柱: '自身·配偶', 时柱: '子女·晚年' };

function Chip({ ch, wx }) {
  return (
    <span className="rel-chip" style={{ borderColor: WX_COLOR[wx] }} title={`${ch}（${wx}）`}>
      <b style={{ color: WX_COLOR[wx] }}>{ch}</b>
      <small>{wx}</small>
    </span>
  );
}

function RelRow({ label, aCh, aWx, bCh, bWx, rel }) {
  // 箭头指向「受方」：生/克＝A作用于B（→），受生/受克＝B作用于A（←）
  const arrow = rel === '生' || rel === '克' ? '⟶' : rel === '比' ? '⇢' : '⟵';
  const note = {
    生: `${aCh}生${bCh}`, 受生: `${bCh}生${aCh}`,
    克: `${aCh}克${bCh}`, 受克: `${bCh}克${aCh}`,
    比: '同气并立',
  }[rel];
  return (
    <div className="rel-row">
      <i className="rel-dim">{label}</i>
      <Chip ch={aCh} wx={aWx} />
      <em className="rel-word" style={{ color: REL_COLOR[rel] }}>{arrow}{rel}{arrow === '⟵' ? '⟶' : ''}</em>
      <Chip ch={bCh} wx={bWx} />
      <span className="rel-note">{note}</span>
    </div>
  );
}

export default function RelationsPanel({ relations }) {
  const [open, setOpen] = useState(null);
  // 日柱为中心的三组排前，其余三组随后
  const ordered = [...relations.filter(r => r.a === '日柱' || r.b === '日柱'),
  ...relations.filter(r => r.a !== '日柱' && r.b !== '日柱')];

  return (
    <section className="panel bz-panel">
      <h4 className="sec-title">柱际关系 · 生克分析（以日主为中心，六组两两）</h4>
      <div className="rel-grid">
        {ordered.map((r) => {
          const key = `${r.a}↔${r.b}`;
          const notable = r.tags.some(t => t.good === false);
          return (
            <button key={key} type="button"
              className={`rel-card ${notable ? 'rel-hot' : ''} ${open === key ? 'on' : ''}`}
              onClick={() => setOpen(open === key ? null : key)}>
              <span className="rel-pair-line">
                <b className="rel-pair">{key}</b>
                <small className="rel-roles">{ROLE[r.a]} ↔ {ROLE[r.b]}</small>
              </span>
              <RelRow label="干" aCh={r.aGan} aWx={GAN_WX[r.aGan]} bCh={r.bGan} bWx={GAN_WX[r.bGan]} rel={r.gRel} />
              <RelRow label="支" aCh={r.aZhi} aWx={ZHI_WX[r.aZhi]} bCh={r.bZhi} bWx={ZHI_WX[r.bZhi]} rel={r.zRelWx} />
              {r.tags.length > 0 && (
                <span className="rel-tags">
                  {r.tags.map((t, i) => (
                    <em key={i} className={t.good === false ? 'bad' : t.good ? 'good' : ''}>{t.name}</em>
                  ))}
                </span>
              )}
            </button>
          );
        })}
      </div>
      {open && (() => {
        const r = relations.find(x => `${x.a}↔${x.b}` === open);
        return (
          <div className="rel-detail">
            <h5>{open} · 宫位详解</h5>
            {r.tags.length > 0 && r.tags.map((t, i) => (
              <p key={i} className="rel-tagline"><b>{t.name}</b>：{t.text}</p>
            ))}
            {r.tags.length === 0 && <p className="rel-tagline"><b>无特殊格局标记</b>：两柱干支间无五合、冲刑害等特殊组合。</p>}
            <p className="rel-meaning">{r.meaning}</p>
          </div>
        );
      })()}
      <p className="bz-tip">
        点击任意一组展开宫位详解；红边＝含冲刑害战克。天干为外象主动事，地支为内里主根基；
        「受生／受克」箭头指向受方，方向勿倒读。
      </p>
    </section>
  );
}
